  <template>
  
  <div>
    <div class="row">
      <div class="card" v-if="nfe">
        <div class="card-body">
          <h4 class="card-title">Entrada de Nota</h4>
          <div class="row">
            <div class="col-md-12">
              <form class="form-horizontal m-t-40" @submit.prevent="gravar()">
                <h5>Dados do Fornecedor:</h5>
                <hr>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Fornecedor</label>
                    <input type="text" class="form-control" v-model="nfe.emit.xFant" readonly>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Razão Social</label>
                    <input type="text" class="form-control" v-model="nfe.emit.xNome" readonly>
                  </div>
                  <div class="form-group col-md-6">
                    <label>CNPJ</label>
                    <input type="text" class="form-control" v-model="nfe.emit.CNPJ" readonly>
                  </div>
                </div>

                <h5>Cobrança:</h5>
                <hr> 
                <div class="row">
                  <template v-if="nfe.cobr && nfe.fat">
                    <div class="form-group col-md-3">
                      <label>Nº da Fatura</label>
                      <input type="text" class="form-control" v-model="nfe.cobr.fat.nFat" readonly>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Valor</label>
                      <input type="text" class="form-control" v-model="nfe.cobr.fat.vOrig" readonly>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Desconto</label>
                      <input type="text" class="form-control" v-model="nfe.cobr.fat.vDesc" readonly>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Valor Líquido</label>
                      <input type="text" class="form-control" v-model="nfe.cobr.fat.vLiq" readonly>
                    </div>
                  </template>

                  <div class="col-md-12">
                    <p class="mt-3 mb-1 bold d-inline mr-2">Duplicatas</p>
                    <button class="btn btn-sm btn-primary" @click="addDup()" type="button">+</button>
                  </div>

                  <template v-if="nfe.cobr">
                    <template v-for="dup of nfe.cobr.dup">
                      <div class="form-group col-md-4">
                        <label>Descrição</label>
                        <input type="text" class="form-control" v-model="dup.nDup">
                      </div>
                      <div class="form-group col-md-4">
                        <label>Vencimento</label>
                        <input class="form-control" type="date" v-model="dup.dVenc">
                      </div>
                      <div class="form-group col-md-4">
                        <label>Valor da duplicata</label>
                        <money type="text" class="form-control" v-model="dup.vDup"></money>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Linha digitável</label>
                        <input type="text" class="form-control" v-model="dup.linha_digitavel">
                      </div>
                      <div class="form-group col-md-3" style="padding-top: 28px">
                        <input :id="'nao_gravar' + dup.nDup" v-model="dup.naoGravar" class="styled-checkbox" type="checkbox">
                        <label :for="'nao_gravar' + dup.nDup" style="vertical-align: top; line-height: 25px;">
                          Não gravar no Financeiro
                        </label>
                      </div>
                    </template>
                  </template>

                  <div v-if="!nfe.cobr" style="display: block; width: 100%; text-align:center; padding: 10px; margin-left: 15px; margin-right: 15px;  background-color: #f6e58d; border-radius: 4px;">
                    Nenhuma cobrança encontrada
                  </div>
                </div>

                <h5>Totais da Nota:</h5>
                <hr>
                <div class="row">
                  <div class="form-group col-md-3">
                    <label>Valor dos Produtos/Serviços</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vProd" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Base de Cálculo do ICMS</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vBC" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor do ICMS</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vICMS" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Base de Cálculo do ICMS ST</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vBCST" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor Total do ICMS ST</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vST" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor do PIS</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vPIS" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor do COFINS</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vCOFINS" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor do IPI</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vIPI" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor Total do Frete</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vFrete" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor Total de Acréscimo</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vOutro" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor Total de Desconto</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vDesc" readonly>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Valor Total da NF-e</label>
                    <input type="text" class="form-control" v-model="nfe.total.ICMSTot.vNF" readonly>
                  </div>
                </div>
                <h5>Produtos:</h5>
                <hr>
                <div v-for="(prod, index) in nfe.det" :key="index">
                  <h5>Produto: #{{index + 1}}</h5>
                  <div class="row">
                    <div class="form-group col-md-2" v-if="prod.prod.cProd">
                      <label>Cód. Forn. </label>
                      <input type="text" class="form-control" v-model="prod.prod.cProd" readonly>
                    </div>
                    <div class="form-group col-md-6">
                      <div class="row" v-show="!prod.prod.produtoVinculado">
                        <div class="form-group col-md-10">
                          <label>Produto <span style="color:orange">(novo)</span></label>
                          <input type="text" class="form-control" v-model="prod.prod.xProd">
                        </div>
                        <div class="form-group col-md-2">
                          <button @click="vincularProduto(index)" data-toggle="tooltip" title="Vincular Produto" type="button" class="btn btn-info px-3 py-2" style="margin-top: 25px;"><i class="fa fa-compress" aria-hidden="true"></i></button>
                        </div>
                      </div>
                      <div class="row" v-show="prod.prod.produtoVinculado">
                        <div class="form-group col-md-10">
                          <label>Produto</label>
                          <v-select label="descricao" @input="alteraValorVenda(prod)" v-model="prod.prod.produto" :clearable="false" :options="produtos"></v-select>
                        </div>
                        <div class="form-group col-md-2">
                          <button @click="desvincularProduto(index)" data-toggle="tooltip" title="Cadastrar Produto" type="button" class="btn btn-info px-3 py-2" style="margin-top: 25px;"><i class="fa fa-expand" aria-hidden="true"></i></button>
                        </div>
                      </div>

                    </div>
                    <div class="form-group col-md-2">
                      <label>NCM</label>
                      <input type="text" maxlength="8" class="form-control" v-model="prod.prod.NCM">
                    </div>
                    <!-- <div class="form-group col-md-2">
                      <label>Unidade Comercial</label>
                      <select class="form-control" @input="teste(prod.prod.unidade)" v-model="prod.prod.unidade">
                        <option value="1" selected>Unidade</option>
                        <option value="2">Caixa</option>
                        <option value="3">Quilo</option>
                        <option value="4">Peca</option>
                        <option value="5">Metro</option>
                        <option value="6">Fardo</option>
                      </select>
                    </div>
                    <div class="form-group col-md-2" v-show="prod.prod.unidade && prod.prod.unidade != 1 && prod.prod.unidade != 3">
                      <label>Quantidade da Unidade</label>
                      <input type="number" class="form-control" @keyup="calculaQuantidade(prod)" v-model="prod.prod.quantidade_unidade">
                    </div> -->
                    <div class="form-group col-md-2">
                      <label>Qtd. Nota</label>
                      <input type="number" class="form-control" step="any" @keyup="calculaUnitario(prod)" v-model="prod.prod.qCom">
                    </div>
                    <div class="form-group col-md-2">
                      <label>Valor de Venda</label>
                      <input type="text" class="form-control" v-model="prod.prod.valor_venda" :required="!prod.prod.gravar">
                    </div>
                    <div class="form-group col-md-2">
                      <label>Valor de Custo</label>
                      <input type="text" class="form-control" v-model="prod.prod.vUnCom" :readonly="prod.prod.produtoVinculado">
                    </div>
                    <div class="form-group col-md-2">
                      <label>Valor Total</label>
                      <input type="text" class="form-control" v-model="prod.prod.vProd" readonly>
                    </div>
                    <div class="form-group col-md-4" v-if="moduloCategoriaFiscal">
                        <label>Categoria</label>
                        <v-select label="descricao" v-model="prod.prod.categoria_fiscal" :clearable="false" :options="categorias" ></v-select>
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <div class="row">
                      <div class="form-group col-lg-2 col-md-3 col-xs-4" v-show="!prod.prod.produtoVinculado">
                        <input v-bind="{ id: 'favorito' + index }" type="checkbox" class="filled-in" v-model="prod.favorito"/>
                        <label v-bind="{ for: 'favorito' + index }" >Favorito</label>
                      </div>
                      <div class="form-group col-lg-2 col-md-3 col-xs-4" v-show="!prod.prod.produtoVinculado">
                        <input v-bind="{ id: 'gravar' + index }" @change="force()" type="checkbox" class="filled-in" v-model="prod.prod.gravar"/>
                        <label v-bind="{ for: 'gravar' + index }"  >Não Gravar</label>
                      </div>
                    </div>
                  </div>
                  <hr>
                </div>
                <div class="form-group col-md-6">
                  <button class="btn btn-info">Gravar</button>
                  <button type="button" @click="limpar()" class="btn btn-default">Limpar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Card } from 'src/components'
import moment from 'moment'
import FiscalService from '@/services/FiscalService.js'
import ProdutoService from '@/services/ProdutoService.js'
import CategoriaFiscalService from '@/services/CategoriaFiscalService.js'
import ErrorService from '@/services/ErrorService.js'

export default {
    components: {
      Card,
    },
    data() {
      return {
        produtos:[],
        nfe: null,
        base64:null,
        notaCarregada: false,
        moduloCategoriaFiscal: localStorage.getItem('config_modulo_categoria_fiscal') == "true" ? true : false,
      }
    },
    methods:{
      alteraValorVenda(produto){
        produto.prod.valor_venda = produto.prod.produto.valor_venda;
        this.$forceUpdate();
      },
      addDup() {
        if(!this.nfe.cobr || !this.nfe.cobr.dup) {
          this.criarCobranca()
        }
        this.nfe.cobr.dup.push({ nDup: '', dVenc: null, vDup: 0})

        this.$forceUpdate()
      },
      criarCobranca() {
        this.nfe.cobr = {
          dup: [],
        }
      },
      calculaUnitario(produto){
        let quantidade = parseFloat(produto.prod.qCom.toString().replace(',','.'));
        if(quantidade > 0){
          produto.prod.vUnCom = (produto.prod.vProd/quantidade).toFixed(2);
        }
        this.$forceUpdate();
      },
      
      vincularProduto(index){
        this.nfe.det[index].prod.produtoVinculado = true;
        this.$forceUpdate();
      },
      desvincularProduto(index){
        this.nfe.det[index].prod.produtoVinculado = false;
        this.$forceUpdate();
      },
      gravar() {
        this.$swal({
          title: 'Cadastrar entrada de nota',
          text: 'Tem certeza que deseja cadastrar essa entrada de nota ?',
          type: 'warning',
          confirmButtonText: 'Prosseguir',
          cancelButtonText: 'Cancelar',
          showCancelButton: true
        }).then(result => {
          if(!result.value){
            return
          }

          FiscalService.salvaNota(this.nfe).then(ret =>{
            if(ret.data){
              this.$swal({
                text: 'Nota gravada com sucesso !',
                type: "success",
              }).then(i => {
                this.$emit('onComplete', this.nfe)
                this.limpar()
              });
            }
          }).catch(error =>{
            console.log(error);
            ErrorService.getMessage(error)
            // this.$swal({
            //     text: error.response.data,
            //     type: "error",
            // });
          });
        });
      },
      limpar() {
        this.$emit('onCancelled', null)
        this.nfe = null;
      },
      force() {
        this.$forceUpdate()
      },
      async setNota(data,file) {
        this.nfe = data
        // var reader = new FileReader();
        // reader.readAsText(file);
        // reader.onload = () => this.nfe.xml = btoa(reader.result);
        let fornecedor = {
          razao_nome: this.nfe.emit.xNome,
          cnpj_cpf: this.nfe.emit.CNPJ,
        };

        FiscalService.produtosVinculado({cnpj:this.nfe.emit.CNPJ}).then(vinculos =>{
          if(vinculos){
            this.nfe.det.forEach(produtos_nota=>{
              vinculos.data.forEach(produtos_viculados=>{
                if(produtos_viculados.codigo_fornecedor == produtos_nota.prod.cProd){
                  for(let produto of this.produtos) {
                    if(produtos_viculados.codigo_produto == produto.codigo) {
                      produtos_nota.prod.produtoPreviamenteVinculado = true;
                      produtos_nota.prod.produtoVinculado = true;
                      produtos_nota.prod.produto = produto;
                      produtos_nota.prod.valor_venda = produto.valor_venda;
                      produtos_nota.prod.categoria_fiscal = this.categorias.find(obj =>obj.codigo == produto.categoria_fiscal);
                    }
                  }
                }
              });
            })
            this.$forceUpdate();  
          }
        });
        
     
      },
      teste(valor){
        this.$forceUpdate();
      },
    },
    mounted() {
      ProdutoService.loadAll().then(ret => {
        this.produtos = ret.data;
        CategoriaFiscalService.load("?no_paginate=1").then(ret =>{
          this.categorias = ret.data;
        });
      });
    }
}
</script>

<style scoped>
  .v-select .dropdown-toggle .clear{
    display: none !important;
  }
  .v-select .open-indicator:before{
    color: #ff275d !important;
    border-color: #ff275d !important;
    height: 5px !important;
    width: 5px !important;
    margin-top: 5px !important;
  }
  .v-select .dropdown-toggle{
    border: none !important;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2) !important;
    font-weight: bold !important;
    margin-bottom: 20px !important;
  }
  .v-select.dropdown .highlight a,
  .v-select.dropdown li:hover a {
    background: #ff275d !important;
    color: #fff !important;
  }
</style>